@if(icon()){
    @if(icon().identifier_1){
      <span><i class="{{ icon().identifier_1 + (iconClasses() ? (' '+iconClasses()) : '') }}"></i></span>
    } @else if (icon().identifier_2) {
      <img [src]="getUrl(icon())" [alt]="icon.name" [ngClass]="imgClasses()"/>
    }
} @else if(fallbackIconClasses()){
    <span><i class="{{ fallbackIconClasses() + (iconClasses() ? (' '+iconClasses()) : '') }}"></i></span>
}